class Ping {

    constructor(opt) {
        this.opt = opt || {};
        this.favicon = this.opt.favicon || '/favicon.ico';
        this.timeout = this.opt.timeout || 0;
        this.logError = this.opt.logError || false;
        this.success = false;
        this.timer = null;
        this.start = null;
    }

    pingAjax(source, callback) {
        this.success = false;
        this.start = new Date();
        this.callback = callback;
        var xhr = new XMLHttpRequest();
        xhr.onload = ((e) => {
            if (xhr.status >= 200 && xhr.status < 300) {
                this.success = true;
                this.check.call(this, e);
            } else {
                this.success = false;
                this.check.call(this, e);
            }
            if (this.timeout) {
                this.timer = setTimeout((() => {
                    this.check.call(this, undefined);
                }).bind(this), this.timeout);
            }
        }).bind(this);
        xhr.onerror = ((e) => {
            this.success = false;
            this.check.call(this, e);
        }).bind(this);
        xhr.open('GET', source + '?' + (+new Date()));
        xhr.send();
    }

    ping(source, callback) {
        this.success = false;
        this.img = new Image();
        this.start = new Date();
        this.callback = callback;

        this.img.onload = ((e) => {
            console.log('image onload triggered');
            this.success = true;
            this.check.call(this, e);
        }).bind(this);

        this.img.onerror = ((e) => {
            console.log('image onerror triggered');
            this.success = false;
            this.check.call(this, e);
        }).bind(this);

        if (this.timeout) {
            this.timer = setTimeout((() => {
                this.check.call(this, undefined);
            }).bind(this), this.timeout);
        }
        // image load cache buster
        this.img.src = source + '?' + (+new Date());
    }

    check() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        let pong = new Date() - this.start;
        if (typeof this.callback == 'function') {
            if (!this.success) {
                if (this.logError) {
                    console.error('Error loading resource');
                }
                return this.callback('error', pong);
            }
            return this.callback(null, pong);
        }
    }
}

export default Ping;
